"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.constrain = constrain;
exports.default = void 0;
exports.formatCurrency = formatCurrency;
exports.formatPercent = formatPercent;
exports.formatPhoneNumber = formatPhoneNumber;
exports.value = value;

require("core-js/modules/es6.regexp.replace.js");

var _numeral = _interopRequireDefault(require("numeral"));

var _isNaN = _interopRequireDefault(require("lodash/isNaN"));

/**
 * Utility module for number related helper functions.
 *
 */
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

/**
 * Constrains the number between the min and max values.
 *
 * @param {number} num The number to be constrained to.
 * @param {number} min The minimum limit
 * @param {number} max The maximum limit.
 *
 * @returns {number}
 */
function constrain(num, min, max) {
  return Math.min(Math.max(num, min), max);
}

function formatCurrency(input, includeCents) {
  var formatted = input;
  var formatString = '$0,0';

  if (includeCents) {
    formatString += '.00';
  }

  if ((0, _isNaN.default)(formatted)) {
    formatted = 0;
  }

  return (0, _numeral.default)(formatted).format(formatString);
}

function formatPercent(input, formatterStr) {
  var formatted = input;

  if ((0, _isNaN.default)(formatted)) {
    formatted = 0;
  }

  return (0, _numeral.default)(formatted).format(formatterStr || '0.0[00]%');
}

function value(formattedInput) {
  return (0, _numeral.default)(formattedInput).value();
}

function formatPhoneNumber(phone) {
  if (typeof phone !== 'string') {
    return '';
  }

  var newPhone = phone.replace(/[^\d]/g, '');

  switch (newPhone.length) {
    case 10:
      // 1231231234 -> (123) 123-1234
      newPhone = newPhone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
      break;

    case 11:
      // +18001231234 -> (800) 123-1234
      newPhone = newPhone.replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, '($2) $3-$4');
      break;

    default: // return phone number as is

  }

  return newPhone;
}

var _default = {
  constrain: constrain,
  formatCurrency: formatCurrency,
  formatPercent: formatPercent,
  value: value,
  formatPhoneNumber: formatPhoneNumber
};
exports.default = _default;